import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Wizard-style accordion that organizes configuration into collapsible steps
 * with completion indicators.
 */
const WizardAccordion = ({ openSections, toggleSection, completionState, sections }) => {
  return (
    <div className="wizard-accordion">
      {/* Progress summary */}
      <div className="d-flex align-items-center mb-3 px-1">
        <small className="text-muted">
          {Object.values(completionState).filter(Boolean).length} of {Object.keys(completionState).length} sections
          complete
        </small>
        <div className="flex-grow-1 mx-3" style={{ height: '4px', backgroundColor: '#e9ecef', borderRadius: '2px' }}>
          <div
            style={{
              height: '100%',
              width: `${(Object.values(completionState).filter(Boolean).length / Object.keys(completionState).length) *
                100}%`,
              backgroundColor: '#253746',
              borderRadius: '2px',
              transition: 'width 0.3s ease'
            }}
          />
        </div>
      </div>

      <Accordion
        open={openSections}
        toggle={toggleSection}
        style={{
          '--bs-accordion-active-bg': '#fff',
          '--bs-accordion-active-color': 'inherit',
          '--bs-accordion-btn-focus-box-shadow': 'none'
        }}
      >
        {sections.map((section, index) => (
          <AccordionItem key={section.id} className="mb-2 border rounded overflow-hidden">
            <AccordionHeader targetId={section.id}>
              <div className="d-flex align-items-center w-100">
                <span
                  className="d-inline-flex align-items-center justify-content-center me-3 flex-shrink-0"
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    backgroundColor: completionState[section.id] ? '#253746' : '#e9ecef',
                    color: completionState[section.id] ? '#fff' : '#6c757d',
                    fontSize: '0.75rem',
                    fontWeight: 600
                  }}
                >
                  {completionState[section.id] ? (
                    <FontAwesomeIcon icon="check" style={{ fontSize: '0.7rem' }} />
                  ) : (
                    index + 1
                  )}
                </span>
                <span className="fw-semibold" style={{ fontSize: '0.95rem' }}>
                  {section.title}
                </span>
                {completionState[section.id] && section.summary && (
                  <Badge color="light" className="ms-auto me-3 text-muted fw-normal" style={{ fontSize: '0.75rem' }}>
                    {section.summary}
                  </Badge>
                )}
              </div>
            </AccordionHeader>
            <AccordionBody accordionId={section.id}>{section.content}</AccordionBody>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

WizardAccordion.propTypes = {
  openSections: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  toggleSection: PropTypes.func.isRequired,
  completionState: PropTypes.object.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      summary: PropTypes.string
    })
  ).isRequired
};

export default WizardAccordion;
